var _circle, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBall6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    viewBox: "0 0 5 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    fill: "url(#paint0_radial_316_70)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.70455 3.01989C2.61979 3.01989 2.5393 3.00663 2.46307 2.98011C2.38731 2.95312 2.32008 2.91075 2.26136 2.85298C2.20265 2.79522 2.15649 2.71993 2.12287 2.62713C2.08973 2.53433 2.07339 2.42187 2.07386 2.28977C2.07434 2.17187 2.08949 2.06581 2.11932 1.97159C2.14962 1.87737 2.19247 1.79711 2.24787 1.73082C2.30374 1.66454 2.3705 1.61387 2.44815 1.57884C2.5258 1.54332 2.61222 1.52557 2.70739 1.52557C2.81439 1.52557 2.90862 1.54616 2.99006 1.58736C3.0715 1.62855 3.13636 1.68371 3.18466 1.75284C3.23343 1.8215 3.26184 1.89725 3.26989 1.98011H2.88068C2.87169 1.93892 2.85085 1.90885 2.81818 1.88991C2.78598 1.8705 2.74905 1.8608 2.70739 1.8608C2.62453 1.8608 2.56368 1.89678 2.52486 1.96875C2.48651 2.04072 2.46686 2.13542 2.46591 2.25284H2.47443C2.4929 2.20833 2.52083 2.17022 2.55824 2.13849C2.59564 2.10677 2.6392 2.08239 2.68892 2.06534C2.73864 2.0483 2.79119 2.03977 2.84659 2.03977C2.93466 2.03977 3.0116 2.05966 3.07741 2.09943C3.1437 2.1392 3.19531 2.19366 3.23224 2.26278C3.26918 2.33191 3.28741 2.41098 3.28693 2.5C3.28741 2.60417 3.26278 2.69531 3.21307 2.77344C3.16383 2.85156 3.09541 2.91217 3.00781 2.95526C2.92022 2.99834 2.81913 3.01989 2.70455 3.01989ZM2.7017 2.72159C2.741 2.72159 2.7758 2.71259 2.80611 2.6946C2.83688 2.67661 2.8608 2.65199 2.87784 2.62074C2.89536 2.58949 2.90388 2.55398 2.90341 2.5142C2.90388 2.47396 2.89536 2.43845 2.87784 2.40767C2.8608 2.37642 2.83688 2.3518 2.80611 2.33381C2.7758 2.31581 2.741 2.30682 2.7017 2.30682C2.67282 2.30682 2.64607 2.31203 2.62145 2.32244C2.5973 2.33239 2.57623 2.34683 2.55824 2.36577C2.54025 2.38423 2.52604 2.40625 2.51562 2.43182C2.50568 2.45691 2.50047 2.48437 2.5 2.5142C2.50047 2.55398 2.50947 2.58949 2.52699 2.62074C2.54451 2.65199 2.56842 2.67661 2.59872 2.6946C2.62902 2.71259 2.66335 2.72159 2.7017 2.72159Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_316_70",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(2.5 2.5) rotate(90) scale(2.5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#66FF66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00CC00"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBall6);
export default __webpack_public_path__ + "static/media/ball6.5257928e0345e47b0ea820ea247361ed.svg";
export { ForwardRef as ReactComponent };